import Zap from "@uui/Zap";
import { isEmpty } from "lodash/fp";

import { ArrowForwardIos } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";

import ROUTES from "@app/common/routes";
import { pluralizePhrase } from "@app/common/utils";

import { Link } from "@rui/Link";
import { Row } from "@rui/Stack";

import useMeetingReportRecommendations from "../hooks/useMeetingReportRecommendations";

const MeetingRecommendationsBanner = () => {
  const { recommendations } = useMeetingReportRecommendations();
  if (isEmpty(recommendations)) return null;

  return (
    <Row
      spacing={1}
      variant="right"
      sx={{ bgcolor: "shades.primary.50", borderRadius: "8px", p: "6px 12px" }}
    >
      <Zap
        sx={{ height: "16px", width: "16px", color: "shades.primary.500" }}
      />
      <Typography variant="bodySecondaryMed">
        {pluralizePhrase(recommendations.length, "recommendation")}
      </Typography>
      <Link to={ROUTES.recommendationById(recommendations[0].id)}>
        <Button
          sx={{ minWidth: "fit-content" }}
          endIcon={<ArrowForwardIos sx={{ height: "16px", width: "16px" }} />}
        >
          View
        </Button>
      </Link>
    </Row>
  );
};

export default MeetingRecommendationsBanner;
